import {Routes, Route,BrowserRouter} from 'react-router-dom';
import { useAdminAuthContext } from './administrator/admin/useAdminAuthContext';
import { AdminLogin } from './administrator/admin/AdminLogin';
import { AdminDashboard } from './administrator/admin/AdminDashboard';
import { AdminManage } from './administrator/admin/AdminManage';
import { AdminCreate } from './administrator/admin/AdminCreate';

import Hikmat from './search/Hikmat';
import AboutHikmat from "./search/AboutHikmat";

function App() {

  const {admin} = useAdminAuthContext();

  return (
    <BrowserRouter>
          <Routes>
            
                {/* Admin related routes */}
                <Route path='/administrator/login' element={<AdminLogin />} />
                <Route path='/administrator/dashboard' element=
                {
                  admin ?
                        <AdminDashboard />
                        :
                        <AdminLogin />
                } />
                <Route path='/administrator/admin/manage' element=
                {
                  admin ?
                        <AdminManage />
                        :
                        <AdminLogin />
                } />
                <Route path='/administrator/admin/create' element=
                {
                  admin ?
                        <AdminCreate />
                        :
                        <AdminLogin />
                } />


              <Route
                  path='/'
                  element={<Hikmat />}
              />

              <Route path="/about" element={<AboutHikmat />} />
              


          </Routes>
    </BrowserRouter>
  );
}

export default App;
